











































































import {Component, Vue} from "vue-property-decorator";
import {querySpu} from '@/services/api'
import SpuManage from "@/model/Spu";
import axios from "@/services/request";
import Loading from "@/components/common/loading.vue";

@Component({
  components: {
    'zf-loading': Loading
  }
})
export default class SpuSearchList extends Vue {
  // 控制列表高度
  public tableHeight = 360;
  // 上传图片地址
  public uploadUrl = (process.env.VUE_APP_BASE_API.length == 0 ? (location.origin + "/") : process.env.VUE_APP_BASE_API) + 'api/util/uploadImages';
  // 上传表单
  public formData: {condition: string, name: string} = {
    condition: '',
    name: ''
  }
  // 图片加载中
  public imgLoading = false;
  // 表格加载
  public loading = false;
  // 列表数据
  public tableData: SpuManage[] = []
  // selectedList 选中的列表
  public selectedList: SpuManage[] = [];

  /**
   * 初始化方法
   */
  async created(): Promise<void> {
    // this.querySpu();
  }

  /**
   * 查询spuList
   */
  querySpu() {
    this.loading = true;
    querySpu(this.formData, false).then(res => {
      if (res.data && res.data.code === 200) {
        this.tableData = res.data.data || [];
        this.loading = false;
      }
    }).catch(() => {
      this.loading = false;
    })
  }

  /**
   * 上传spu图片
   */
  uploadSpuImg() {
    console.log(this.$refs)
    const upload:any = this.$refs.upload;
    upload.click()
  }

  /**
   * 图片上传
   */
  async handleUploadChange(i:any) {
    try{
      this.imgLoading = true;
      this.formData.condition = '';
      if (i.target?.files?.length > 0) {
        let params = new FormData()
        params.append('file', i.target.files[0]);
        await axios.post(this.uploadUrl, params).then(res => {
          if (res.data && res.data.result[0]) {
            this.formData.condition = res.data.result[0];
          }
        })
      }
    } catch (e) {}
    this.imgLoading = false;
  }

  /**
   * 查询
   */
  search(): void {
    this.querySpu();
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * 打开新的窗口
   */
  openWindow(url: string): void {
    window.open(url,'_blank')
  }

  /**
   * 选择变化钩子
   * @param selectedList
   */
  handleSelectionChange(selectedList: SpuManage[]) {
    this.selectedList = selectedList;
  }

  /**
   * 确认选择
   */
  confirm() {
    console.log(this.selectedList)
    this.$emit('confirm', this.selectedList);
  }

  /**
   * 取消关闭
   */
  close() {
    this.$emit('close');
  }
}

